import React from "react";
import { Button, Empty, message, Popconfirm, Tooltip } from "antd";
import {
  DownloadOutlined,
  FileOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { downloadFromUrl } from "../utils/downloadUtils";

const AttachmentsView = ({
  attachments = [],
  onDeleteAttachment = null,
  canDelete = false,
  isDeleting = false,
}) => {
  const handleDownload = async (url, filename) => {
    try {
      await downloadFromUrl(url, filename);
    } catch (err) {
      message.error("Failed to download file.");
    }
  };

  if (!attachments?.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No attachments"
        className="my-4"
      />
    );
  }

  return (
    <div className="w-full">
      <ul className="list-none p-0 m-0 border rounded-lg divide-y">
        {attachments.map((file) => (
          <li
            key={file._id}
            className="p-3 flex items-center justify-between hover:bg-gray-50"
          >
            <div className="flex items-center gap-2 flex-1 min-w-0">
              <FileOutlined className="text-gray-400 text-lg" />
              <Tooltip title={file.filename} placement="topLeft">
                <span
                  className="text-sm line-clamp-2 break-all max-w-xs"
                  style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'normal' }}
                >
                  {file.filename}
                </span>
              </Tooltip>
            </div>
            <div className="flex items-center">
              <Tooltip title="Download file">
                <Button
                  type="text"
                  size="small"
                  icon={<DownloadOutlined />}
                  onClick={() => handleDownload(file.url, file.filename)}
                />
              </Tooltip>

              {canDelete && onDeleteAttachment && (
                <Tooltip title="Delete attachment">
                  <Popconfirm
                    title="Are you sure you want to delete this attachment?"
                    onConfirm={() => onDeleteAttachment(file._id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="text"
                      size="small"
                      danger
                      icon={<DeleteOutlined />}
                      loading={isDeleting}
                    />
                  </Popconfirm>
                </Tooltip>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AttachmentsView;
